export default {
    to: "/dashboard/waas/channel-codes",
    order: 3,
    icon: "mdi-quadcopter",
    title: "Channel Codes",
    disabled: false,
    value: 0,
}
